import React, { useEffect, useState } from 'react'
import CustomerForm from '../../components/Forms/Customer/CustomerForm'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import { useCustomer } from '../../hooks/Features/useCustomer'
import { ROUTES } from '../../shared/constants'

export default function AddCustomer({ customer }) {
  const { addCustomer, updateCustomer } = useCustomer()
  const [customerForm, setCustomerForm] = useState({
    name: '',
    leadSource: '',
    designation: '',
    phoneNumber: '',
    email: '',
    state: '',
    city: '',
    pincode: '',
    address: '',
    siteAddress: '',
    gstNumber: '',
    profilePicture: '',
    customerType: '',
    addedBy: '',
    active: true,
    salutation: '',
    countryCode: '',
  })
  
  //console.log('CUSTOMER : ', customerForm)
  const handleAddCustomer = () => {
    if (customer) {
      updateCustomer({
        CustomerId: customer._id,
        phoneNumber: customerForm.phoneNumber,
        profilePicture: customerForm.profilePicture,
        name: customerForm.name,
        email: customerForm.email,
        state: customerForm.state,
        pincode: customerForm.pincode,
        designation: customerForm.designation,
        address: customerForm.address,
        gstNumber: customerForm.gstNumber,
        city: customerForm.city,
        customerType: customerForm.customerType,
        siteAddress: customerForm.siteAddress,
        addedBy: customerForm.addedBy,
        active: customerForm.active,
        salutation: customerForm.salutation,
        countryCode: customerForm.countryCode,
      })
    } else {
      console.log(customerForm)
      addCustomer({
        phoneNumber: customerForm.phoneNumber,
        profilePicture: customerForm.profilePicture,
        name: customerForm.name,
        email: customerForm.email,
        state: customerForm.state,
        pincode: customerForm.pincode,
        designation: customerForm.designation,
        address: customerForm.address,
        gstNumber: customerForm.gstNumber,
        city: customerForm.city,
        active: customerForm.active,
        customerType: customerForm.customerType,
        siteAddress: customerForm.siteAddress,
        addedBy: customerForm.addedBy,
        salutation: customerForm.salutation,
        countryCode: customerForm.countryCode,
      })
    }
  }

  useEffect(() => {
    if (customer) {
      setCustomerForm({
        ...customerForm,
        phoneNumber: customer.phoneNumber,
        profilePicture: customer.profilePicture,
        name: customer.name,
        email: customer.email,
        state: customer.state,
        pincode: customer.pincode,
        designation: customer.designation,
        address: customer.address,
        gstNumber: customer.gstNumber,
        city: customer.city,
        customerType: customer.customerType,
        siteAddress: customer.siteAddress,
        active: customer.active,
        addedBy: customer.addedBy && customer.addedBy._id,
        salutation: customer.salutation,
        countryCode: customerForm.countryCode,
      })
    }
  }, [customer])

  return (
    <Layout heading="Customer" heading2={customer ? 'Edit' : 'Add'} url1={ROUTES.CUSTOMERS} none>
      <HeaderTabLayout
        heading={`${customer ? 'Edit' : 'Add'} Customer`}
        content={<CustomerForm form={customerForm} setForm={setCustomerForm} address={customerForm.address}
        setAddress={(val) => {
          setCustomerForm({ ...customerForm, address: val })
        }}
        setCoordinages={(ll)=>{
          console.log(ll)
        }} />}
        state={customerForm} setState={setCustomerForm}
        addContent={handleAddCustomer}
        redirect={ROUTES.CUSTOMERS}
      />
    </Layout>
  )
}
